import axios from "axios";
import apiUrl from "../../../urls/apiUrls";

export const homePageWidgetList = async (page) => {
  try {
    const homePageResponse = await axios.get(
      `${apiUrl.homePageBaseUrl}/page/home`
    );

    if (homePageResponse.status === 200) {
      return homePageResponse;
    }
  } catch (e) {
 
    return e.response;
  }
};

export const homeSearchPlacesList = async (page) => {
  try {
    const searchList = await axios.get(
      `${apiUrl.homePageBaseUrl}/search/home/metadata`
    );

    if (searchList.status === 200) {
      return searchList;
    }
  } catch (e) {
 
    return e.response;
  }
};
